import { render, staticRenderFns } from "./UserTargetProgressionEdit.vue?vue&type=template&id=d852cd3a&"
import script from "./UserTargetProgressionEdit.vue?vue&type=script&lang=js&"
export * from "./UserTargetProgressionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports